import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared';
import { contactQueryLinkerSchema } from '@/_pages/contacts/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { nullableBooleanQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';

import { companyFilteredSchema, pickerSchema, pickerTypeSchema } from './linked-schemas';

import { deliveryMethodQuerySchema } from '../components/delivery-method';
import { removalCauseQuerySchema } from '../components/removal-cause';
import { statusQuerySchema } from '../components/status';
import { pickTicketsItemQuerySchema } from '../pick-ticket-items-schemas';

export const pickTicketsQuerySchema = z.object({
  id: z.number(),
  pick_number: z.number(),

  client_id: z.number().nullable(),
  client: companyFilteredSchema.nullable(),
  contacts: z.array(contactQueryLinkerSchema).nullable(),

  picker_id: z.number().nullable(),
  picker: pickerSchema.nullable().refine((val) => typeof val?.id === 'number', {
    error: 'Picker is required',
  }),
  picked_at: z.string().nullable(),
  picker_type: pickerTypeSchema.nullable(),

  status: statusQuerySchema.nullable(),

  delivery_method: deliveryMethodQuerySchema.nullable(),

  tracking_number: z.string().nullable(),
  remove_items: nullableBooleanQuerySchema(),
  why_removed: removalCauseQuerySchema.nullable(),
  why_removed_comment: z.string().nullable(),

  notes: z.string().nullable(),
  delivery_address: z.array(addressQuerySchema).nullish(),
  attached_documents: z.array(fileQuerySchema).nullish(),

  pick_ticket_items: z.array(pickTicketsItemQuerySchema).nullish(),
});

export type PickTicketsQuerySchema = z.infer<typeof pickTicketsQuerySchema>;

export const pickTicketsQueryAllSchema = paginatedResponseSchema(pickTicketsQuerySchema);

export type PickTicketsQueryAllSchema = z.infer<typeof pickTicketsQueryAllSchema>;
